import { make } from "vuex-pathify";
import store from "../..";

const state = {
    completing: false,
};

const mutations = make.mutations(state);

const actions = {
    async actived({commit, dispatch}, payload) {
        let action = payload

        try {
            commit("completing", action.uncompleted());

            await store.get("actions/completing");

            commit("completing", false);
        } catch (error) {
            throw error
        }
    },

    async completed({commit, dispatch}, payload) {
        let action = payload

        try {
            commit("completing", action.completed());

            await store.get("actions/completing");

            commit("completing", false);
        } catch (error) {
            throw error
        }
    },
};

const getters = {
    //
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
